import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { requestPasswordReset } from "../api/auth";
import logoSmall from "../assets/logo_orange.svg";

export function ForgotPassword() {
  const { t } = useTranslation();
  const [identifier, setIdentifier] = useState("");
  const [status, setStatus] = useState({ state: "idle", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = identifier.trim();
    if (!trimmed) {
      setStatus({ state: "error", message: t("validation.identifier.required") });
      return;
    }
    setSubmitting(true);
    try {
      await requestPasswordReset(trimmed);
      setStatus({
        state: "success",
        message: t("login.forgotPasswordSuccessBody"),
      });
    } catch (err) {
      const messageKey = err.response?.data?.message_key;
      const message = err.response?.data?.message;
      setStatus({
        state: "error",
        message: t(messageKey || "errors.generic", {
          defaultValue: message || t("errors.generic"),
        }),
      });
    } finally {
      setSubmitting(false);
    }
  };

  const isDisabled = status.state === "success";

  return (
    <div className="login-screen">
      <div className="login-brand">
        <img alt={t("login.logoAlt")} className="login-logo" src={logoSmall} />
        <h1>{t("app.title")}</h1>
        <p className="login-tagline">{t("app.tagline")}</p>
      </div>

      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-card__header">
          <h2 className="login-title">{t("login.forgotPasswordTitle")}</h2>
          <p className="login-subtitle">{t("login.forgotPasswordSubtitle")}</p>
        </div>

        {status.state === "error" && (
          <div className="login-status login-status--error">{status.message}</div>
        )}
        {status.state === "success" && (
          <div className="login-status login-status--success">
            <strong>{t("login.forgotPasswordSuccessTitle")}</strong>
            <p>{status.message}</p>
          </div>
        )}

        <div className="login-field">
          <label htmlFor="identifier">{t("login.forgotPasswordIdentifierLabel")}</label>
          <input
            id="identifier"
            name="identifier"
            placeholder={t("login.forgotPasswordIdentifierPlaceholder")}
            value={identifier}
            onChange={(event) => setIdentifier(event.target.value)}
            disabled={isDisabled || submitting}
            autoComplete="username"
            required
          />
        </div>

        <button className="login-submit" type="submit" disabled={isDisabled || submitting}>
          {submitting ? t("common.saving") : t("login.forgotPasswordSubmit")}
        </button>

        <div className="login-links">
          <a href="/login" className="login-link-primary">{t("login.backToLogin")}</a>
          <a href="/register" className="login-link-secondary">{t("login.registerLink")}</a>
        </div>
      </form>
    </div>
  );
}
